import {
    MASTER_UNIT_ITEM,
    MASTER_UNIT_ITEM_FAILURE,
    MASTER_UNIT_ITEM_SUCCESS
} from "../../../constant/master/MasterUnitConstant";

const initialState = {
    masterUnitItem: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};

export const MasterUnitItemReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case MASTER_UNIT_ITEM:
            return {
                ...state,
                masterUnitItem: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case MASTER_UNIT_ITEM_SUCCESS:
            return {
                ...state,
                masterUnitItem: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case MASTER_UNIT_ITEM_FAILURE:
            return {
                ...state,
                masterUnitItem: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
